import styled from 'styled-components'

export const MobileList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  width: 100%;

  margin: 0;
  padding: 0;
  list-style: none;

  .noOrders {
    padding: 2rem 1rem;
    text-align: center;

    font-weight: 500;
    color: ${({ theme }) => `rgba(${theme.grayscale[100]}, 0.9)`};
  }
`

export const ListContent = styled.li`
  display: flex;
  flex-direction: column;
  gap: 2.75rem;

  border: 1px solid ${({ theme }) => `rgb(${theme.component.accent})`};
  border-radius: 6px;

  padding: 1.5rem 1rem;

  .cardHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;

    font-size: 0.875rem;
    font-weight: 700;
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
  }

  .cardIcon {
    margin: 0;
    padding: 0;

    width: 2.5rem;
    height: 2.5rem;

    img {
      width: 100%;
      height: 100%;

      object-fit: contain;
    }
  }

  .cardBody {
    display: flex;
    justify-content: center;

    p {
      margin: 0;

      font-size: 1.125rem;
      font-weight: 600;
      color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};

      text-align: center;
    }
  }

  .cardFooter {
    display: flex;
    justify-content: space-between;
    gap: 0.5rem;

    div {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.5rem;

      text-align: center;

      span {
        font-size: 0.875rem;
        font-weight: 700;
        color: ${({ theme }) => `rgb(${theme.grayscale.neutral})`};
      }

      span:first-child {
        color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
      }
    }
  }
`
